var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { SACardVariantMinimal, SACardVariantSimple, SACardVariantStandard, SACardVariantStandardTabbed, SACardVariantSub, SACardVariantSubTitled, SACardVariantSubTitledNoUnderline, } from './variants';
export function SACard(_a) {
    var actionLabel = _a.actionLabel, actionLabelClickHandler = _a.actionLabelClickHandler, activeTabIndex = _a.activeTabIndex, addVerticalSeparator = _a.addVerticalSeparator, children = _a.children, decorator = _a.decorator, height = _a.height, jsxElement = _a.jsxElement, onSubVariantClick = _a.onSubVariantClick, tabChangeEventHandler = _a.tabChangeEventHandler, removePadding = _a.removePadding, tabs = _a.tabs, title = _a.title, variant = _a.variant, width = _a.width, rest = __rest(_a, ["actionLabel", "actionLabelClickHandler", "activeTabIndex", "addVerticalSeparator", "children", "decorator", "height", "jsxElement", "onSubVariantClick", "tabChangeEventHandler", "removePadding", "tabs", "title", "variant", "width"]);
    var content = children !== undefined ? children : ' ';
    switch (variant) {
        case 'minimal': {
            return (React.createElement(SACardVariantMinimal, __assign({ height: height, removePadding: removePadding, width: width }, rest), content));
        }
        case 'simple': {
            return (React.createElement(SACardVariantSimple, __assign({ actionLabel: actionLabel, actionLabelClickHandler: actionLabelClickHandler, height: height, removePadding: removePadding, title: title, width: width }, rest), content));
        }
        case 'standard': {
            return (React.createElement(SACardVariantStandard, __assign({ actionLabel: actionLabel, actionLabelClickHandler: actionLabelClickHandler, height: height, jsxElement: jsxElement, removePadding: removePadding, title: title, width: width }, rest), content));
        }
        case 'standard-tabbed': {
            return (React.createElement(SACardVariantStandardTabbed, __assign({ activeTabIndex: activeTabIndex, tabs: tabs, tabChangeEventHandler: tabChangeEventHandler }, rest), content));
        }
        case 'sub': {
            return (React.createElement(SACardVariantSub, __assign({ height: height, onSubVariantClick: onSubVariantClick, removePadding: removePadding, width: width }, rest), content));
        }
        case 'sub-titled': {
            return (React.createElement(SACardVariantSubTitled, __assign({ addVerticalSeparator: addVerticalSeparator, decorator: decorator, height: height, removePadding: removePadding, title: title, width: width }, rest), content));
        }
        case 'sub-titled-no-underline': {
            return (React.createElement(SACardVariantSubTitledNoUnderline, __assign({ addVerticalSeparator: addVerticalSeparator, decorator: decorator, height: height, removePadding: removePadding, title: title, width: width }, rest), content));
        }
        default: {
            return React.createElement("div", __assign({}, rest), "SACard: variant not found.");
        }
    }
}
SACard.defaultProps = {
    height: undefined,
    removePadding: false,
    title: '',
    width: undefined,
};
//# sourceMappingURL=card.component.js.map